export default __webpack_public_path__ + "static/media/google-play-badge.cfe26084.svg";